import { useMutation } from '@tanstack/react-query';
import type { StartWidgetChatRequest, StartWidgetChatResponse } from 'server';
import { appFetch } from './appFetch';

export const useStartChat = () => {
  return useMutation({
    mutationFn: async (request: StartWidgetChatRequest): Promise<StartWidgetChatResponse> => {
      const response = await appFetch<StartWidgetChatResponse>('/app/public/widget/start', {
        method: 'POST',
        body: request
      });
      return response;
    }
  });
};
